import { rem } from 'polished';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Flex, Link, NakedButton, RegionLinks } from '@qga/roo-ui/components';

export const FooterWrapper = styled(Flex)`
  border-top: ${themeGet('space.1')} solid;
  border-color: ${themeGet('colors.brand.primary')};
  background: ${(props) => props.backgroundColor};
  padding: ${themeGet('space.2')} 0 ${themeGet('space.12')};
  flex-direction: column;
`;

export const ScrollToTopButton = styled(NakedButton)`
  width: ${rem('48px')};
  height: ${rem('48px')};
  color: ${themeGet('colors.greys.charcoal')};
  background-color: ${themeGet('colors.white')};
  border: 1px solid ${themeGet('colors.white')};
`;

export const FooterLink = styled(Link)`
  line-height: 1.5;
  font-size: ${themeGet('fontSizes.sm')};
  padding-right: ${themeGet('space.4')};
  color: ${themeGet('colors.white')};
`;

export const Logo = styled.img`
  height: ${rem('30px')};
`;

type LinkStyleProps = {
  color?: string;
  fontSize?: string;
  mb?: number;
};
export const StyledRegionLinks = styled(RegionLinks)<LinkStyleProps>``;
